import axios from "axios";

const LIVE_BASE = process.env.REACT_APP_API_LIVE_URL;

const SURVEY_REGISTER_SAVE_LEAD = `${LIVE_BASE}/register`;

class UserService {
    // saveUser(user) {
    //     return axios.post(API_URL + "/saveUser", user);
    // }
    saveRegister(registerUser) {
        return axios.post(SURVEY_REGISTER_SAVE_LEAD, registerUser);
    }
}

export default new UserService